import { _request, APIBaseResponse, APIMethod } from '..';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const USER_GROUP_PATH_PREFIX = 'usergrouprolememberships';

type APIRoleUserGroupGetParams = RequestParamsBase & {
    tenantId: string;
    userGroupId: string
};

type APIRoleUserGroupGetResponse = APIBaseResponse<
    Array<{
        roleId: string;
        roleName: string;
        userGroupId: string;
        userGroupName: string;
}>>;

export const APIRoleUserGroupGetList: APIMethod<APIRoleUserGroupGetParams, APIRoleUserGroupGetResponse> = params => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}?userGroupId=${params.userGroupId}`, undefined, params.signal));

type APIRoleUserGroupPostParams = {
    tenantId: string;
    userGroupId: string
};

type APIRoleUserGroupPostResponse = APIBaseResponse<string>;

export const APIRoleUserGroupPost: APIMethod<APIRoleUserGroupPostParams, APIRoleUserGroupPostResponse> = params => (
    _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}`, params));

type APIRoleUserGroupDeleteParams = {
    tenantId: string;
    roleId: string;
    userGroupId: string;
}

export const APIRoleUserGroupDelete: APIMethod<APIRoleUserGroupDeleteParams, APIBaseResponse> = params => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}?roleId=${params.roleId}&userGroupId=${params.userGroupId}`)
);
